import React from 'react';

interface ProgressBarProps {
    currentStep: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ currentStep }) => {
    const progressWidth = currentStep === 1 ? '25%' : currentStep === 2 ? '50%' : currentStep === 3 ? '75%' : '100%';

    return (
        <div className="bg-white p-4 rounded-lg shadow-md">
            <div className="flex items-center">
                <div className="flex-1">
                    <div className="w-full bg-gray-200 rounded-full h-2.5">
                        <div
                            className="bg-magenta h-2.5 rounded-full transition-all duration-500"
                            style={{ width: progressWidth }}
                        ></div>
                    </div>
                </div>
            </div>
            <div className="flex justify-between text-sm text-black mt-2">
                <div className="text-center w-1/4">
                    <p className={`font-medium ${currentStep >= 1 ? '' : 'text-gray-400'}`}>Schritt 1</p>
                    <p className={`text-xs ${currentStep >= 1 ? '' : 'text-gray-400'}`}>Teilnahme</p>
                </div>
                <div className="text-center w-1/4">
                    <p className={`font-medium ${currentStep >= 2 ? '' : 'text-gray-400'}`}>Schritt 2</p>
                    <p className={`text-xs ${currentStep >= 2 ? '' : 'text-gray-400'}`}>Details</p>
                </div>
                <div className="text-center w-1/4">
                    <p className={`font-medium ${currentStep >= 3 ? '' : 'text-gray-400'}`}>Schritt 3</p>
                    <p className={`text-xs ${currentStep >= 3 ? '' : 'text-gray-400'}`}>Einverständnis</p>
                </div>
                <div className="text-center w-1/4">
                    <p className={`font-medium ${currentStep >= 4 ? '' : 'text-gray-400'}`}>Schritt 4</p>
                    <p className={`text-xs ${currentStep >= 4 ? '' : 'text-gray-400'}`}>Bestätigung</p>
                </div>
            </div>
        </div>
    );
};

export default ProgressBar;
